import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import LocationDetailsTab from '../../../features/locations/LocationDetailsTab';
import { useNewLocationMutation, useModifyLocationMutation } from '../../../api/locations';

const AddEditLocation = (props) => {
    const params = useParams();
    const [locationDetails, setLocationDetails] = useState({});
    const location = useLocation();
    const isEditMode = location.pathname.includes('edit');
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();
    const [newLocation, { isLoading: isNewLoading }] = useNewLocationMutation();
    const [modifyLocation, { isLoading: isModifyLoading }] = useModifyLocationMutation();

    const isLoading = isNewLoading || isModifyLoading;

    useEffect(() => {
        const fetchData = async () => {
            const bodyFormData = new FormData();
            try {
                let response;
                if (isEditMode) {
                    bodyFormData.append('id', params.id);
                    response = await modifyLocation(bodyFormData).unwrap();
                } else {
                    response = await newLocation(bodyFormData).unwrap();
                }
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setLocationDetails(response);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        };

        fetchData();
    }, [params.id, isEditMode, newLocation, modifyLocation, enqueueSnackbar]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">{isEditMode ? 'Edit Location' : 'Add Location'}</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/locations')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <LocationDetailsTab
                                isEditMode={isEditMode}
                                locationDetails={locationDetails}
                                isLoading={isLoading}
                            />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AddEditLocation;
